/**
 * @generated SignedSource<<0427e597049aca34d00bc7437170c8ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WAFileSettingsQuery$variables = {
  fileIds: ReadonlyArray<string>;
};
export type WAFileSettingsQuery$data = {
  readonly listFiles: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WAFileSettings_file">;
  }>;
};
export type WAFileSettingsQuery = {
  response: WAFileSettingsQuery$data;
  variables: WAFileSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "fileIds",
    "variableName": "fileIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WAFileSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "listFiles",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WAFileSettings_file"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WAFileSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "listFiles",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOrg",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "289fa23bff1d59d606418632f2140994",
    "id": null,
    "metadata": {},
    "name": "WAFileSettingsQuery",
    "operationKind": "query",
    "text": "query WAFileSettingsQuery(\n  $fileIds: [ID!]!\n) {\n  listFiles(fileIds: $fileIds) {\n    id\n    ...WAFileSettings_file\n  }\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment WAFileSettings_file on File {\n  id\n  name\n  ...FileIcon_File\n}\n"
  }
};
})();

(node as any).hash = "4b27dd50e30184d959dcae95befd0a7e";

export default node;
